// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__Tb7Cs","menuItemIcon":"MenuItem_menuItemIcon__EgqsP","menuItemText":"MenuItem_menuItemText__J35IE"};